<template>
    <transition
        @enter="enterTransition"
        @leave="leaveTransition"
        :css="false"
        appear
    >
        <div class="oc-loading-holder" :class="[size, {transparent, fixed}]">
            <div class="oc-loading-backdrop modal-backdrop show" v-class="{dark: !transparent}" v-if="backdrop"></div>
            <div class="oc-loading-box" :style="{color: color}">
                <slot>
                    <slot name="icon">
                        <oc-spinner size="small" v-if="icon === 'oc-spinner'" />

                        <oc-icon
                            v-else-if="icon"
                            :type="icon"
                            v-bind="iconAttrs"
                            class="loading-icon fa-spin"
                        />
                    </slot>
                    <slot name="text">
                        <span
                            v-if="displayText"
                            class="oc-loading-text"
                            v-bind="textAttrs"
                            v-text="text"
                        />
                    </slot>
                </slot>
            </div>
        </div>
    </transition>
</template>

<script>
import Velocity from 'velocity'

export default {
    name: 'oc-loader',
    props: {
        backdrop: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: true
        },
        transparent: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['big', 'normal', 'small'].indexOf(value) !== -1
            }
        },
        icon: {
            type: [String, Boolean],
            default: 'oc-spinner'
        },
        iconAttrs: {
            type: Object,
            default: () => ({})
        },
        color: {
            type: String,
            default: '#999999'
        },
        text: {
            type: [String, Boolean],
            default: 'Loading ...'
        },
        textAttrs: {
            type: Object,
            default: () => ({})
        },
        animation: {
            type: [Boolean, String],
            default: 'ease',
            validator: function (value) {
                return [false, 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out'].indexOf(value) !== -1
            }
        }
    },
    computed: {
        displayText() {
            return this.text && this.size !== 'small'
        }
    },
    methods: {
        enterTransition (el, done) {
            if(false === this.animation) {
                return done()
            }
            Velocity(el, "fadeIn", { duration: 350, easing: this.animation, complete: done})
        },
        leaveTransition (el, done) {
            if(false === this.animation) {
                return done()
            }
            Velocity(el, "fadeOut", { delay: 300, duration: 350, easing: this.animation, complete: done})
        }
    }
}
</script>

<style scoped>
.oc-loading-holder {
    transition: max-height 0.15s ease-out;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 16777270;
}

.oc-loading-box {
    background: #fcfcfc;
    text-align: center;
    z-index:9999;
    position:absolute;
    transition:top 1s linear;
    top:50%;
    left:50%;
    border:solid 1px #ccc;
    border-radius:4px;
}
.oc-loading-holder.transparent .oc-loading-box {
    background:none;
    border:none;
}

.oc-loading-text {
    display: block;
    padding-top: 4px;
}

.oc-loading-holder.big .oc-loading-box {
    margin:-50px 0 0 -65px;
    padding:15px 20px;
    width:140px;
}
.oc-loading-holder.big .loading-icon {
    font-size:40px;
}
.oc-loading-holder.big .oc-loading-text {
    font-size:14px;
}

.oc-loading-holder.normal .oc-loading-box {
    margin:-45px 0 0 -65px;
    padding:15px 10px;
    width:130px;
}
.oc-loading-holder.normal .loading-icon {
    font-size:30px;
}
.oc-loading-holder.normal .oc-loading-text {
    font-size:13px;
    color: #000;
}

.oc-loading-holder.small .oc-loading-box {
    margin:-30px 0 0 -20px;
    padding:15px 10px;
    width:60px;
}
.oc-loading-holder.small .loading-icon {
    font-size:22px;
}

.oc-loading-backdrop {
    opacity: .5;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9998;
    background-color: #fff;
}

.oc-loading-backdrop.dark {
    background-color: #999;
}

.oc-loading-holder.fixed {
    position: fixed;
}

/* -------------------------- */

.oc-loading-box >>> .oc-loading-spinner {
    margin: 0 10px 5px 10px;
}
</style>
